import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-305850d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex col" }
const _hoisted_2 = { class: "flex align-center grow justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Roles", -1))
const _hoisted_4 = { class: "grow flex align-end justify-end" }
const _hoisted_5 = {
  class: "flex",
  style: {"align-items":"stretch"}
}
const _hoisted_6 = {
  class: "flex col p12",
  style: {"flex":"2 0 0","background-color":"#f3fafa","border-radius":"12px"}
}
const _hoisted_7 = { class: "flex align-center" }
const _hoisted_8 = {
  id: "roleGrid",
  class: "grid flex col tag-panel"
}
const _hoisted_9 = { class: "flex col p12 tag-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_SeEditableText = _resolveComponent("SeEditableText")!
  const _component_WideCard = _resolveComponent("WideCard")!
  const _component_SeCheckboxGroup = _resolveComponent("SeCheckboxGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SeButton, {
          ref: "saveBtn",
          onPress: _ctx.save,
          tooltip: "Save",
          icon: "/ico/save.svg"
        }, null, 8, ["onPress"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_SearchBar, {
            targetGridId: "roleGrid",
            class: "grow"
          }),
          _createVNode(_component_SeButton, {
            onPress: _ctx.addRole,
            icon: "/ico/plus.svg"
          }, null, 8, ["onPress"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.employee_roles, (role) => {
            return (_openBlock(), _createBlock(_component_WideCard, {
              class: _normalizeClass(_ctx.selectedRole == role ? 'selected-role' : ''),
              icon: "ico/employee_role_blue.svg",
              onClick: () => _ctx.selectRole(role)
            }, {
              body: _withCtx(() => [
                _createVNode(_component_SeEditableText, {
                  modelValue: role.name,
                  "onUpdate:modelValue": ($event: any) => ((role.name) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              footer: _withCtx(() => []),
              _: 2
            }, 1032, ["class", "onClick"]))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createVNode(_component_SeCheckboxGroup, {
          title: "Extensions",
          class: "p12",
          ref: "extensionsSelect",
          labelFunction: _ctx.getLabelFromI18N,
          items: _ctx.getExtensionEnums()
        }, null, 8, ["labelFunction", "items"]), [
          [_vShow, _ctx.selectedRole != null]
        ])
      ])
    ])
  ]))
}